import axios from "axios";
import router from "@/router";
import VueCookies from "vue-cookies";
import config from "@/config";
import commons from "@/utils/commons.js";

axios.defaults.timeout = 30 * 1000;
axios.defaults.responseType = "json";
// axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.common["Cache-Control"] = "no-cache"; // 禁用缓存
axios.defaults.headers.common["remoteType"] = config.remoteType;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.baseUrl;

const whiteUris = [
  "news/web/article/articleCategoryList",
  "news/web/article/articleList",
  "news/web/article/getById",
  "/system/user/checkUserName",
  "recruit/web/recruit/noticeList",
  "recruit/web/recruit/getById",
  "recruit/web/recruit/getTeacherList",
  "/recruit/employee/register",
  "system/user/forgetPassword",
  "recruit/web/post/getList",
  "news/web/advertisement/list",
  "system/web/system/getDicByCode",
  "/train/web/company/list",
  "news/web/article/articleTreeList",
  "recruit/web/recruit/getReNature",
  "recruit/web/recruit/getReExperience",
  "recruit/web/recruit/getRecruitEducation",
  "recruit/web/recruit/getReScale",
  "recruit/web/recruit/getReFinancing",
  "recruit/web/recruit/getNoticeByMajorCategory",
  "recruit/web/recruit/getNoticeBySysPost",
  "news/web/article/getByIdParticulars",
  "recruit/web/recruit/getNoticeList",
  "recruit/web/recruit/getSeacherButton",
  "web/specialist/exportTemplate",
  "news/web/article/enterpriseList",
  "recruit/web/choosePostRecruit/choosePostRecruitList",
  "recruit/web/choosePostRecruit/getChoosePostInfoById",
  "/train/web/course/courselist",
  "/train/web/course/courseSylist",
  "/train/web/course/courselistByLecturer",
  "/train/web/lecturer/getById",
  "/train/web/lecturer/lecturerlist",
  "/train/web/lecturer/getDictDataInfo",
  "/train/web/course/getById",
  "/train/web/course/keChengList",
  "/train/web/lecturer/list",
  "/train/web/lecturer/lecturerSylist",
  "/message/visit/addCount",
  "recruit/web/recruit/getHostRecruit",
  "/train/web/examination/getRemindExam",
]; // 请求拦截白名单

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    let uri = config.url;
    if (config.url.indexOf("wps") > -1) {
      config.baseURL = "";
      delete config.headers.common.Authentication;
      delete config.headers.common.remoteType;
      delete config.headers.common["Cache-Control"];
    } else {
      if (whiteUris.indexOf(uri) == -1) {
        console.log("uri", uri);
        let token = VueCookies.get(commons.User.Authentication);
        if (!token) {
          let redirectPath = router.currentRoute.fullPath;
          if (redirectPath.indexOf("login") == -1) {
            router.push({
              // 首次进浏览器展示首页
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }
        } else {
          config.headers.common.Authorization = VueCookies.get(
            commons.User.Authentication
          );
        }
      } else if (config.params && config.params.Authentication) {
        config.headers.common.Authorization = config.params.Authentication;
        delete config.params.Authentication;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (
      response.data == null &&
      response.config.responseType === "json" &&
      response.request.responseText != null
    ) {
      try {
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    if (response.data.code == commons.RespCode.needLogin) {
      VueCookies.remove(commons.User.Authentication);
      VueCookies.remove(commons.User.userId);
      VueCookies.remove(commons.User.realName);
      VueCookies.remove(commons.User.headUrl);
      let redirectPath = router.currentRoute.fullPath;
      if (redirectPath.indexOf("login") == -1) {
        router.push({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      }
    } else if (response.data.code == commons.RespCode.noAuthority) {
    }
    return response;
  },
  (error) => {
    if (error.response.status == 401) {
      let redirectPath = router.currentRoute.fullPath;
      if (redirectPath.indexOf("login") == -1) {
        router.push({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

/**
 * http post request
 * @param {*} url
 * @param {*} params JSON格式
 * @param {*} data  body 提交数据为JSON格式
 */
const post = (url, params = {}, data = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("url",url)
        console.log("err", err);
        if (url.includes("/train/web/examination/") && !err.response) {
          alert("网络断开!请联系监考人员查看网线连接状态!");
        } 
        reject(err.response.data);
      });
  }).catch((e) => {
    console.error(e);
  });
};
/**
 * http get request
 * @param {*} url
 * @param {*} params
 */
const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("url",url)
        console.log("err", err);
        if (url.includes("/train/web/examination/") && !err.response) {
          alert("网络断开!请联系监考人员查看网线连接状态!");
        } 
        reject(err.response.data);
      });
  }).catch((e) => {
    console.error(e);
  });
};

/**
 * http post request response blob
 * @param {*} url
 * @param {*} data
 */
const downloadFile = (url, params = {}, data = {}) => {
  axios
    .post(url, data, {
      params: params,
      responseType: "blob",
    })
    .then((res) => {
      let fileName = res.headers["content-disposition"];
      fileName = fileName.substring(fileName.indexOf("=") + 1);
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
      let blob;
      if (suffix == "xls" || suffix == "xlsx") {
        blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
      } else if (suffix == "doc" || suffix == "docx") {
        blob = new Blob([res.data], {
          type: "application/vnd.ms-word",
        });
      } else if (suffix == "ppt" || suffix == "pptx") {
        blob = new Blob([res.data], {
          type: "application/vnd.ms-powerpoint",
        });
      } else if (suffix == "pdf") {
        blob = new Blob([res.data], {
          type: "application/pdf",
        });
      } else if (suffix == "jpg") {
        blob = new Blob([res.data], {
          type: "image/jpeg",
        });
      } else if (suffix == "png") {
        blob = new Blob([res.data], {
          type: "image/png",
        });
      } else if (suffix == "exe") {
        blob = new Blob([res.data], {
          type: "application/x-msdownload",
        });
      } else if (suffix == "zip") {
        blob = new Blob([res.data], {
          type: "application/zip",
        });
      } else if (suffix == "rar") {
        blob = new Blob([res.data], {
          type: "application/x-rar-compressed",
        });
      }
      if ("download" in document.createElement("a")) {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        navigator.msSaveBlob(blob, fileName);
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

export default {
  post,
  get,
  downloadFile,
  uploadFile: `${config.baseUrl}/file/upload`,
  uploadEditerFile: `${config.baseUrl}/file/uploadUpFile?remoteType=${config.remoteType}`,
};



// WEBPACK FOOTER //
// ./src/request/index.js